import React, { useEffect, useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import _ from 'lodash';
import styled from 'styled-components/native';
import { Heading4, BasicText as Text, BasicText } from '../../Styles';
import { Icon } from '../..';
import Modal from '../../core/Modal';
import ServiceRequest from './ServiceRequest';
import { Program } from './Programs';

const RequestIcon = styled(Icon)`
`;

const Services = ({userInfo, services, defaultMaxHeight = 80}) => {
    const groupedServices = _.groupBy(services, "material_name");
    let maxHeight = defaultMaxHeight + 0;
    const requestIconMarginTop = 5;
    const userPortalProfileSettings = userInfo != undefined? userInfo.portalProfileSettings : null;
    
    const blocks = _.map(groupedServices, (serviceGroup, groupKey)=>{
        const equipmentGroups = _.groupBy(serviceGroup, "equipment");
        
        const equipmentTypes = _.keys(equipmentGroups);
        if(equipmentTypes.length > 0){
            const groupLength = (equipmentTypes.length + 2)* 16; //+1 for request line and +1 for the icon line, each row given
            if(groupLength > maxHeight){
                maxHeight = groupLength;
            }
        }

        return <Program 
            key={groupKey}
            colour={serviceGroup[0].material_colour}
            title={groupKey}
            icon={serviceGroup[0].material_icon}
            height={maxHeight+requestIconMarginTop}
            helpIcon={<RequestIcon icon="dumpster" colour="white"/>}
            modalChildren={<ServiceRequest service={serviceGroup[0]} allServices={services} siteId={serviceGroup[0].site} />}
        >
            {_.map(equipmentGroups, (equipmentGroup, key)=><Text key={key} align="center">{key} (Qty: {equipmentGroup[0].quantity_on_site})</Text>)}
            {userPortalProfileSettings != undefined && userPortalProfileSettings.supportAccess? <View style={{flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "50%", marginTop: requestIconMarginTop}}>
                <Text>Request</Text>
                <Icon icon="long-arrow-right" size={15}/>
            </View> : null}
        </Program>
    });

    return <>{blocks}</>;
}

export default Services;